interface props {
  onCloseInPopuUp: () => void;
}
const SvgBranchBackArrow: React.FC<props> = ({ onCloseInPopuUp }) => {
  return (
    <svg
      onClick={onCloseInPopuUp}
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.98807 0.394304C6.83219 0.398949 6.68424 0.464096 6.57557 0.575944L0.575568 6.57594C0.463089 6.68847 0.399902 6.84106 0.399902 7.00016C0.399902 7.15927 0.463089 7.31186 0.575568 7.42438L6.57557 13.4244C6.63085 13.482 6.69708 13.5279 6.77035 13.5596C6.84363 13.5913 6.92249 13.608 7.00232 13.6088C7.08214 13.6096 7.16132 13.5945 7.23523 13.5643C7.30914 13.5342 7.37628 13.4896 7.43273 13.4331C7.48918 13.3767 7.53379 13.3095 7.56397 13.2356C7.59414 13.1617 7.60926 13.0825 7.60845 13.0027C7.60764 12.9229 7.59091 12.844 7.55924 12.7707C7.52756 12.6975 7.48159 12.6312 7.42401 12.5759L1.84822 7.00016L7.42401 1.42438C7.51071 1.3401 7.56993 1.2316 7.5939 1.11309C7.61788 0.994576 7.60549 0.871586 7.55837 0.760234C7.51124 0.648883 7.43158 0.554365 7.32981 0.489068C7.22805 0.42377 7.10893 0.39074 6.98807 0.394304V0.394304Z"
        className={"fill-primary"}
      />
    </svg>
  );
};

export default SvgBranchBackArrow;
